import React, { FC, memo } from 'react';

import { Button } from 'antd';
import { EditOutlined, LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import type { SyncCallback } from '@/types/types';
import RecipientChip from '../../RecipientChip';

import styles from './PasswordView.module.scss';

const nameSpace = 'sharingBlock.recipientsList';

interface PasswordViewProps {
    maskedPassword: string | null;
    enableEditMode: SyncCallback;
}

const PasswordView: FC<PasswordViewProps> = ({
    enableEditMode,
    maskedPassword,
}) => {
    const { t } = useTranslation();

    return (
        <Button
            size="small"
            type="link"
            onClick={enableEditMode}
            data-testid={maskedPassword ? 'uploadDrawer_passwordChip' : 'uploadDrawer_addPasswordButton'}
            className={maskedPassword ? styles['password-edit-btn'] : styles['add-password-button']}
        >
            {maskedPassword ? (
                <>
                    <RecipientChip content={maskedPassword} />
                    <EditOutlined className={styles['edit-icon']} />
                </>
            ) : (
                <>
                    <LockOutlined />
                    <span style={{ marginInlineStart: 2 }}>{t(`${nameSpace}.addPassword`)}</span>
                </>
            )}
        </Button>
    );
};

export default memo(PasswordView);

